import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function ApproveArticle({
  setIsApprove,
  isApprove,
  isChangeLoading,
  handleApproveCounsilor = () => {},
  data,
}) {
  const handleReject = () => {
    handleApproveCounsilor(data);
  };

  return (
    <ModalComp
      title="Approve this article?"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setIsApprove(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isChangeLoading}
          handleSecondaryBtn={handleReject}
          secondaryBtnvariant="primary"
          secondaryBtnText="Submit"
        />
      }
      open={isApprove}
      setOpen={(Value) => setIsApprove(Value)}
    >
      {`Review the changes carefully. Approving will update the article content. `}
    </ModalComp>
  );
}

export default ApproveArticle;
